import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ConsentUseCaseBasicModel} from '@core/modules/rest/consent-use-case/response/consent-use-case-basic.model';
import {IndicationBasicModel} from '@core/modules/rest/indication/response/indication-basic.model';
import {UntilDestroy} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-education-info',
    templateUrl: './education-info.component.html',
    styleUrls: ['./education-info.component.scss']
})
export class EducationInfoComponent implements OnInit {

    @Input() availableIndications: IndicationBasicModel[];
    @Input() useCases: ConsentUseCaseBasicModel[];
    @Input() selectedEducationId: string;
    @Input() selectedUseCase: string;
    @Input() allowCustomUseCase: boolean;
    @Input() hasEducation: boolean;
    @Input() saveDisabled: boolean;
    @Output() saveDisabledEvent = new EventEmitter();
    userId: string;
    useCaseOptions = [];
    basicIndicationSelected: boolean;
    selectedByPatient = false;

    ngOnInit(): void {
        this.useCases?.forEach(useCase => {
            this.useCaseOptions.push({
                selectId: useCase.id,
                selectValue: useCase.title
            });
        });
        this.selectedUseCase = this.selectedUseCase ? this.selectedUseCase : this.useCases[0]?.id;
        this.selectedEducationId = this.selectedEducationId ? this.selectedEducationId : this.availableIndications[0].id;
        this.basicIndicationSelected = this.availableIndications.find(item => item.id === this.selectedEducationId) !== undefined ? this.availableIndications.find(item => item.id === this.selectedEducationId).basicIndication : false;
        this.selectedByPatient = this.selectedUseCase === 'CUSTOM_USE_CASE';
        this.allowCustomUseCase = this.isCustomUseCaseAllowed();
    }

    onClickRadioButtons(value: string): void {
        if (value !== this.selectedEducationId) {
            this.chooseIndication(value);
            this.saveDisabled = false;
            this.saveDisabledEvent.emit(this.saveDisabled);
        }
    }

    chooseIndication(indicationId: string): void {
        const selectIndication = this.availableIndications.find(ind => ind.id === indicationId);
        this.selectedEducationId = selectIndication.id;
        this.basicIndicationSelected = this.availableIndications.find(item => item.id === indicationId).basicIndication;
    }

    onSelectUseCaseChange(useCaseId: string): void {
        const selectedPatientUseCase = this.useCaseOptions.find(item => item.selectId === 'CUSTOM_USE_CASE');
        this.selectedByPatient = useCaseId === selectedPatientUseCase.selectId;
        this.selectedUseCase = useCaseId;
        this.allowCustomUseCase = this.isCustomUseCaseAllowed();
    }

    onAllowCustomUseCase(): void {
        this.allowCustomUseCase = !this.allowCustomUseCase;
    }

    isCheckBoxDisabled(): boolean {
        return this.basicIndicationSelected || !this.selectedByPatient;
    }

    isCustomUseCaseAllowed(): boolean {
        return this.selectedByPatient ? this.allowCustomUseCase : false;
    }
}
